"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyStyles = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _interfaces = require("./interfaces");
const typographyStyles = _ref => {
  let {
    size
  } = _ref;
  const isSmall = size === _interfaces.ButtonSize.Small;
  const fontSize = isSmall ? (0, _utils.token)('text.size.100') : (0, _utils.token)('text.size.200');
  const lineHeight = isSmall ? (0, _utils.token)('text.lineHeight.100') : (0, _utils.token)('text.lineHeight.200');
  return {
    fontSize,
    lineHeight
  };
};
exports.typographyStyles = typographyStyles;